export class PlantRequest {
    plantCode:string;
    constructor(plantCode:string,){
        this.plantCode = plantCode;
    }
}


